import { FormControl, FormErrorMessage, FormLabel, Input } from "@chakra-ui/react";
import { type FieldErrors, type UseFormRegister } from "react-hook-form";

import { type FormValues } from "../useSendShieldedForm";

type MemoFieldProps = {
  register: UseFormRegister<FormValues>;
  errors: FieldErrors<FormValues>;
  isDisabled?: boolean;
};

export const MemoField = ({ register, errors, isDisabled }: MemoFieldProps) => (
  <FormControl isInvalid={!!errors.memo}>
    <FormLabel>Memo (optional)</FormLabel>
    <Input
      isDisabled={isDisabled}
      {...register("memo", {
        maxLength: {
          value: 8,
          message: "Memo must be 8 characters or less",
        },
      })}
      maxLength={8}
      placeholder="Optional memo"
    />
    {errors.memo && (
      <FormErrorMessage data-testid="memo-error">{errors.memo.message}</FormErrorMessage>
    )}
  </FormControl>
);
